import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useAuth } from "../hooks/AuthProvider";

function NavBarContainer(props) {
  const auth = useAuth();
  return (
    <Navbar expand="lg" className="bg-body-tertiary gradient-background">
      <Container>
        <Navbar.Brand>Southcott Crimpers</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="justify-content-end" style={{ width: "100%" }}>
            <Nav.Link onClick={() => props.setIndex(0)}>Profile</Nav.Link>
            <Nav.Link onClick={() => props.setIndex(1)}>Map</Nav.Link>
            <Nav.Link onClick={() => props.setIndex(2)}>Reports</Nav.Link>
            <Nav.Link onClick={() => props.setIndex(4)}>Loading</Nav.Link>
            <Nav.Link onClick={() => auth.logout()}>Log Out</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
export default NavBarContainer;
